
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import { applyStyle } from 'ol-mapbox-style';
import { Style, Fill, Stroke, Text } from 'ol/style';
import { FeatureLike } from "ol/Feature";
import { mapState } from '../map';

/**
 * Mapped type for the VARIANTS constant map
 */
export type KatasterVariants = {
  [variant: string]: string
}

/**
 * Available Basemap variants
 */
export const VARIANTS: KatasterVariants = {
  kataster: 'https://kataster.bev.gv.at/tiles/kataster/{z}/{x}/{y}.pbf',
  symbole: 'https://kataster.bev.gv.at/tiles/symbole/{z}/{x}/{y}.pbf'
};

export const STYLE_VARIANTS: KatasterVariants = {
  kataster_vermv: 'https://kataster.bev.gv.at/styles/kataster/style_vermv.json',
  kataster_ortho: 'https://kataster.bev.gv.at/styles/kataster/style_ortho.json',
  kataster_basic: 'https://kataster.bev.gv.at/styles/kataster/style_basic.json',
  kataster_gis: 'https://kataster.bev.gv.at/styles/kataster/style_gis.json',
  symbole_vermv: 'https://kataster.bev.gv.at/styles/symbole/style_vermv.json',
  symbole_ortho: 'https://kataster.bev.gv.at/styles/symbole/style_ortho.json',
  symbole_basic: 'https://kataster.bev.gv.at/styles/symbole/style_basic.json',
  symbole_gis: 'https://kataster.bev.gv.at/styles/symbole/style_gis.json'
};

const adminLayers = ['bl', 'blp', 'pg', 'pgp', 'kg', 'kgp'];
const katasterLayer = ['gst', 'gnr', 'nfl'];



export const DKM = 'DKM';




export const  getDigitaleKatastralmappeSource = () => new VectorTileSource({
  overlaps: false,
  format: new MVT({ layers: katasterLayer, idProperty: 'id' }),
  url: VARIANTS.kataster,
  minZoom: 6, // needed in order to enable overzoom
  maxZoom: 16, // needed in order to enable overzoom
});


export const digitaleKatastralmappeLayer = new VectorTileLayer({
  source: getDigitaleKatastralmappeSource(),
  declutter: true,
});

if (digitaleKatastralmappeLayer instanceof VectorTileLayer) {
  applyStyle(digitaleKatastralmappeLayer, "https://kataster.bev.gv.at/styles/kataster/style_ortho.json", { accessToken: 'YOUR_MAPBOX_TOKEN' });
}



const lightPink = [255, 182, 193];
const black = [0, 0, 0];
const emptyStyle = new Style({});


const adminStyle = (width: number, minResolution: number, maxResolution: number) => {
  return (feature: FeatureLike, resolution: number) => {
    if (resolution >= maxResolution && resolution < minResolution) {
      return [
        new Style({
          stroke: new Stroke({
            color: lightPink,
            width: width,
          }),
        }),
        new Style({
          stroke: new Stroke({
            color: black,
            width: width / 3,
            lineDash: [width],
          }),
        }),
        new Style({
          stroke: new Stroke({
            color: black,
            width: width / 3,
            lineDash: [width],
          }),
        }),
      ];
    } else {
      return emptyStyle;
    }
  };
};

const adminLabel = new Text({
  font: '12px Arial,sans-serif',
  //overflow: true,
  fill: new Fill({
    color: '#000',
  }),
  stroke: new Stroke({
    color: '#f1ddcf',
    width: 3,
  }),
  overflow: false,
});

const adminPointStyle = (field: string, minResolution: number, maxResolution: number, prefix = '') => {
  return (feature: FeatureLike, resolution: number) => {
    if (resolution >= maxResolution && resolution < minResolution) {
      adminLabel.setText(prefix + feature.get(field));
      return new Style({
        text: adminLabel,
      });
    } else {
      return emptyStyle;
    }
  };
};

const provinceStyle = adminStyle(4, 1000, 0.1);
const provincePointStyle = adminPointStyle('bl', 1000, 100);
const communityStyle = adminStyle(2, 300, 0.1);
const communityPointStyle = adminPointStyle('pg', 70, 50, 'PK: ');
const catastralCommunityStyle = adminStyle(3, 50, 0.1);
const catastralCommunityPointStyle = adminPointStyle('kg', 50, 0.1, 'KG: ');

export const adminLayerStyle = (feature: FeatureLike, resolution: number) => {
  const layer = feature.get('layer');
  switch (layer) {
    case 'bl':
      return provinceStyle(feature, resolution);
    case 'blp':
      return provincePointStyle(feature, resolution);
    case 'pg':
      return communityStyle(feature, resolution);
    case 'pgp':
      return communityPointStyle(feature, resolution);
    case 'kg':
      return catastralCommunityStyle(feature, resolution);
    case 'kgp':
      return catastralCommunityPointStyle(feature, resolution);
    default:
      return emptyStyle; // cadastral community is not displayed.
  }
};


export const ADM = 'ADM';

export const adminLayer = new VectorTileLayer({
  renderMode: 'vector',
  source: new VectorTileSource({
    format: new MVT({ layers: adminLayers, idProperty: 'id' }),
    url: VARIANTS.kataster,
    minZoom: 6, // needed in order to enable overzoom
    maxZoom: 15, // needed in order to enable overzoom
  }),
  style: adminLayerStyle,
  visible: true
});


export const getGstFid = (feature:FeatureLike) => {
  const kg = feature.get('kg');
  const gnr = feature.get('gnr');
  return (kg && gnr) ? `${kg}_${gnr}` : undefined;
};




